import storeModuleFactory from 'util/storeModule/storeModuleFactory';
import endpoints from 'config/endpoints';
import {TIMEOUT_STORE, TIMESTAMP_MULTIPLY} from 'util/constants';

const exports = storeModuleFactory({
    name:            'backupsHosts',
    endpoint:        endpoints.backupsHosts.endpoint,
    timeout:         TIMEOUT_STORE.TIMEOUT_STORE_BIG,
    parseParameters: params => ({
        start_date: Math.floor(params.startDate / TIMESTAMP_MULTIPLY),
        end_date:   Math.floor(params.endDate / TIMESTAMP_MULTIPLY)
    })
});

module.exports = exports;



// WEBPACK FOOTER //
// ./src/modules/store/backupsHosts.js